import Vue from 'vue'
import App from './App.vue'
import router from './router'

import UIkit from 'uikit'
import Icons from 'uikit/dist/js/uikit-icons'

import VueResource from 'vue-resource'

import VueDisqus from 'vue-disqus'

import Moment from 'moment'

import '@/sass/style.sass'

Vue.use(VueResource)

Vue.use(VueDisqus)

Vue.prototype.moment = Moment
Moment.locale('ko-KR')

Vue.http.options.root = 'https://api.suuon.net/wp-json'

// Vue.http.options.root = 'http://demo.wp-api.org/wp-json'

UIkit.use(Icons)

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
